<template>
  <div>
    <v-container class="container not-printable" fluid>
      <v-card elevation="6">
        <v-row style="margin: 10px">
          <v-col cols="10">
            <h3>الطباعة</h3>
          </v-col>
          <v-col cols="2" align="left">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="mx-2" fab small color="primary" @click="$router.go(-1)" v-bind="attrs" v-on="on">
                  <v-icon dark> mdi-arrow-left </v-icon>
                </v-btn>
              </template>
              <span>رجوع</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-card>
    </v-container>

    <div style="border: 2px solid #252525; margin-top: 5px" class="center-print">
      <div>
        <v-row class="print-padding">
          <v-col cols="4">
            <h3>رقم الوصل : {{ voucher.idExpenses }}</h3>
            <h3>تاريخ الوصل : {{ voucher.expensesDateFormat }}</h3>
          </v-col>

          <v-col cols="4">
            <v-img :src="require('../assets/logo.png')" class="my-3" contain height="200" />
          </v-col>
          <v-col cols="4"> </v-col>
        </v-row>
        <div>
          <v-row>
            <v-col cols="4"></v-col>
            <v-col cols="4">
              <h3>جامعة التراث / الحسابات</h3>
              <h3>سند دفع</h3>
              <!-- <img id="barcode" /> -->

              <VueBarcode :value="voucher.idExpenses" displayValue="false" width="3" height="50"> Show this if the rendering fails. </VueBarcode>
            </v-col>
            <v-col cols="4"></v-col>
          </v-row>
          <v-divider style="background: #000"></v-divider>
          <v-row class="print-padding">
            <v-col cols="4">
              <h3>اسم الحساب</h3>
            </v-col>
            <v-col cols="8">
              <h3>{{ voucher.typeName }}</h3>
            </v-col>
          </v-row>
          <v-divider style="background: #000"></v-divider>
          <v-row>
            <v-col cols="4">
              <h3 style="padding: 10px">مدين</h3>
            </v-col>
            <v-col cols="4">
              <h3>
                {{
                  voucher.amount.toLocaleString("en-US" )
                }}
              </h3>
            </v-col>
            <v-col cols="4">
              <h3>{{ numberWriting }} فقط لا غير</h3>
            </v-col>
          </v-row>

          <v-divider style="background: #000"></v-divider>

          <v-row class="print-padding">
            <v-col cols="4">
              <h3>البيان</h3>
            </v-col>
            <v-col cols="8">
              <h3>{{ voucher.notes }}</h3>
            </v-col>
          </v-row>
          <v-divider style="background: #000"></v-divider>

          <v-divider style="background: #000"></v-divider>
          <v-row class="print-padding">
            <v-col cols="3"><h3>اسم المستلم وتوقيعه</h3></v-col>
            <v-col cols="3"><h3>المدقق</h3></v-col>
            <v-col cols="3"><h3>امين الصندوق</h3></v-col>
            <v-col cols="3"><h3>مدير الحسابات</h3></v-col>
          </v-row>
        </div>
      </div>
      <button @click="print()" class="not-printable">print</button>
    </div>
  </div>
</template>

<script>
import n2wordsAR from "n2words/lib/i18n/AR.mjs";
var JsBarcode = require("jsbarcode");
import VueBarcode from "vue-barcode";

export default {
  components: {
    VueBarcode,
  },
  props: {
    invoice: String,
  },
  data() {
    return {
      voucher: null,
      show: false,
      numberWriting: "",
    };
  },
  created() {
    this.voucher = JSON.parse(this.invoice);
    console.log(this.voucher.collegeNumber);
    this.numberWriting = n2wordsAR(this.voucher.amount, { lang: "ar" });

    setTimeout(() => {
      JsBarcode("#barcode", `${this.voucher.collegeNumber}`, {
        width: 3,
        height: 30,
        displayValue: false,
      });
    }, 200);
    this.show = true;
  },
  methods: {
    print() {
      window.print();
    },
  },
  filters: {
    setLevel: function (level) {
      if (level == 1) {
        return "المرحلة الاولى";
      } else if (level == 2) {
        return "المرحلة الثانية";
      } else if (level == 3) {
        return "المرحلة الثالثة";
      } else if (level == 4) {
        return "المرحلة الرابعة";
      } else if (level == 5) {
        return "المرحلة الخامسة";
      } else {
        return "متخرج";
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
